// extracted by mini-css-extract-plugin
module.exports = {"storeSearchInput":"StoreSearchInput_storeSearchInput__EFAyN","clearButton":"StoreSearchInput_clearButton__3hZbJ"};